"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Input = _interopRequireDefault(require("../../Atoms/Input"));
require("./Quantity.scss");
var Quantity = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(Quantity, _React$Component);
  function Quantity(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: props.value
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateInput = _this.validateInput.bind((0, _assertThisInitialized2.default)(_this));
    _this.onKeyUp = _this.onKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.getNumber = _this.getNumber.bind((0, _assertThisInitialized2.default)(_this));
    _this.getValue = _this.getValue.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // eslint-disable-next-line react/no-deprecated

  var _proto = Quantity.prototype;
  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var value = this.state.value;
    var parseValue = this.getNumber(value);
    if (nextProps.value && nextProps.value !== parseValue) {
      this.setState({
        value: nextProps.value
      });
    }
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    var disabled = props.disabled,
      isFreeItem = props.isFreeItem;
    return !(disabled && !isFreeItem);
  };
  _proto.getValue = function getValue(value) {
    var quantity = (0, _lodash.parseInt)(value);
    return typeof quantity === 'number' ? quantity : value;
  };
  _proto.onChange = function onChange(value) {
    var maxLength = this.props.maxLength;
    var status = this.validateInput(value);
    if (status) {
      if (value > maxLength) {
        this.setState({
          value: maxLength
        });
      } else {
        this.setState({
          value: value
        });
      }
    }
  };
  _proto.onBlur = function onBlur(e) {
    e.preventDefault();
    var _this$props = this.props,
      value = _this$props.value,
      updateCartQuantity = _this$props.updateCartQuantity;
    var inputValue = e.target.value;
    var status = this.validateInput(inputValue);
    var parseValue = this.getNumber(inputValue);
    if (status && parseValue !== value && !(0, _lodash.isEmpty)(inputValue)) {
      updateCartQuantity(this.getValue(inputValue));
    }
    if (status && (parseValue === value || (0, _lodash.isEmpty)(inputValue))) {
      this.setState({
        value: value
      });
    }
  };
  _proto.onKeyUp = function onKeyUp(e) {
    e.preventDefault();
    if (e.keyCode === 13 || e.charCode === 13) {
      var _this$props2 = this.props,
        value = _this$props2.value,
        updateCartQuantity = _this$props2.updateCartQuantity;
      var inputValue = e.target.value;
      var status = this.validateInput(inputValue);
      var parseValue = this.getNumber(inputValue);
      if (status && parseValue !== value && !(0, _lodash.isEmpty)(inputValue)) {
        updateCartQuantity(this.getValue(inputValue));
      }
      if (status && (parseValue === value || (0, _lodash.isEmpty)(inputValue))) {
        this.setState({
          value: value
        });
      }
    }
  };
  _proto.getNumber = function getNumber(value) {
    var number = value;
    if (!(0, _lodash.isEmpty)(number)) {
      number = (0, _lodash.parseInt)(value);
    }
    return number;
  };
  _proto.validateInput = function validateInput(value) {
    var minLength = this.props.minLength;
    var status = true;
    var regex = /(^\d+$|^$)/;
    if ((0, _lodash.isEmpty)(value)) {
      return status;
    }
    if (value < minLength || !regex.test(value)) {
      status = false;
    }
    return status;
  };
  _proto.render = function render() {
    var _this$props3 = this.props,
      className = _this$props3.className,
      minLength = _this$props3.minLength,
      maxLength = _this$props3.maxLength,
      placeholder = _this$props3.placeholder,
      disabled = _this$props3.disabled,
      elementLocator = _this$props3.elementLocator,
      id = _this$props3.id;
    var value = this.state.value;
    return _react.default.createElement("div", {
      className: "quantity " + className
    }, _react.default.createElement(_Input.default, {
      id: id,
      type: "text",
      name: "qty",
      placeholder: placeholder,
      ariaLabel: "quantity",
      value: value,
      minLength: minLength,
      maxLength: maxLength,
      onChange: this.onChange,
      onBlur: this.onBlur,
      onKeyUp: this.onKeyUp,
      disabled: disabled,
      elementLocator: elementLocator
    }));
  };
  return Quantity;
}(_react.default.Component);
Quantity.defaultProps = {
  className: '',
  placeholder: '',
  value: '',
  minLength: 0,
  maxLength: 999,
  updateCartQuantity: function updateCartQuantity() {
    /* default updateCartQuantity handler */
  },
  disabled: false,
  elementLocator: '',
  id: '',
  isFreeItem: false
};
var _default = Quantity;
exports.default = _default;
module.exports = exports["default"];